import { jsx as _jsx } from "react/jsx-runtime";
var FileUpload = function FileUpload(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: /*#__PURE__*/_jsx("path", {
      d: "M6.555 20h10.889c.307 0 .556-.224.556-.5V10h-3.286C13.217 10 12 8.722 12 7.15V4H6.555C6.249 4 6 4.224 6 4.5v15c0 .276.249.5.555.5ZM16.742 8 14 4.978V7.15c0 .469.32.85.714.85h2.028Zm-2.446-5.672 5.444 6A1 1 0 0 1 20 9v10.5c0 1.378-1.147 2.5-2.556 2.5H6.555C5.146 22 4 20.878 4 19.5v-15C4 3.122 5.146 2 6.555 2h7a1 1 0 0 1 .741.328Zm-1.91 7.75c.12.05.23.123.321.215l3 3a1 1 0 0 1-1.415 1.414L13 13.414V17a1 1 0 1 1-2 0v-3.664L9.69 14.585a1 1 0 1 1-1.38-1.447l3-2.862c.023-.023.05-.038.078-.053.018-.01.036-.02.052-.031l.042-.03a.696.696 0 0 1 .144-.087c.087-.035.18-.045.271-.055.016-.002.03-.006.045-.01.019-.005.037-.01.057-.01l.006.001c.13 0 .26.026.38.077Z",
      fill: color
    })
  });
};
export default FileUpload;